import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { PrudencioProvider } from "@domestika-dev/prudencio/dist/PrudencioProvider";
import LanguageProvider from "../utils/languageProvider";
import configureStore from "../utils/store";
import { translationMessagesFactory } from "../../../../config/react/i18n";

const store = configureStore({});
window.locale = I18n?.locale || "es";
const locale = document.querySelector("body")?.dataset?.locale;

const patchI18n = async () => {
  if (window.Intl) {
    return;
  }

  await import("intl");
  await Promise.all([
    import("intl/locale-data/jsonp/es.js"),
    import("intl/locale-data/jsonp/en.js"),
    import("intl/locale-data/jsonp/de.js"),
    import("intl/locale-data/jsonp/pt.js"),
    import("intl/locale-data/jsonp/fr.js"),
    import("intl/locale-data/jsonp/it.js"),
    import("intl/locale-data/jsonp/pl.js"),
    import("intl/locale-data/jsonp/nl.js"),
  ]);
};

const ProviderWrapper = ({ children }) => {
  const [messagesAsync, setMessages] = useState(false);
  useEffect(() => {
    translationMessagesFactory(locale).then(async (messages) => {
      await patchI18n();
      setMessages({ [locale]: messages });
    });
  }, []);

  if (!messagesAsync) {
    return null;
  }

  return (
    <Provider store={store}>
      <PrudencioProvider>
        <LanguageProvider messages={messagesAsync} locale={locale}>
          {React.Children.only(children)}
        </LanguageProvider>
      </PrudencioProvider>
    </Provider>
  );
};

ProviderWrapper.propTypes = {
  children: PropTypes.element.isRequired,
};

export default ProviderWrapper;
